import { css } from 'emotion';

import Style from '../../styles/common';

export const baseInput = css`
  background-color: ${Style.color.INPUT.BACKGROUND};
  border: 1px solid ${Style.color.INPUT.BORDER};
  border-radius: ${Style.BORDER_RADIUS};
  display: block;
  font-family: ${Style.FONT_FAMILY.DEFAULT};
  font-size: ${Style.FONT_SIZE.M};
  font-weight: ${Style.FONT_WEIGHT.LIGHT};
  letter-spacing: 0.25px;
  line-height: 1.75;
  outline: none;
  padding: 1rem 1.25rem;
  transition: border-color 0.1s;
  width: 100%;

  ::placeholder {
    color: ${Style.color.PLACEHOLDER};
  }
`;

export const getBorderColor = ({ active, error, touched }) => {
  if (touched && error) return Style.color.ERROR;
  if (active) return Style.color.INPUT.BORDER_ACTIVE;
  return Style.color.INPUT.BORDER;
};



// WEBPACK FOOTER //
// ./src/components/Form/Styles.js